import React from "react";
import Select, { components } from "react-select";
import './css/style.css';
import DropdownArrowDown from './img/dropdownArrow-Down.svg';
import DropdownCloseIcon from './img/close-icon.svg';

const SwSingleSelect = ({ options, selectedValue, onChange, isMulti = false, placeholder = "Select an option..." }) => {
  
  // Custom Dropdown Arrow
  const SwSelectArrow = (props) => (
    <components.DropdownIndicator {...props}>
      <img src={DropdownArrowDown} alt="Dropdown Arrow" width={10} className="SwSelect_DD_Arrow" />
    </components.DropdownIndicator>
  );

  // Custom Clear Indicator (Close Icon)
  const SwClearIndicator = (props) => (
    <components.ClearIndicator {...props}>
      <img src={DropdownCloseIcon} alt="Clear" width={10} style={{ cursor: "pointer" }} />
    </components.ClearIndicator>
  );

  // SW Select Style
  const SwSelectStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#1E1E2D" : "#fff",
      "&:hover": {
        backgroundColor: "#323242",
      },
    }),
  };

  return (
    <Select
      value={selectedValue}
      onChange={onChange}
      options={options}
      className="SwSelect"
      components={{
        DropdownIndicator: SwSelectArrow,
        ClearIndicator: SwClearIndicator,
        IndicatorSeparator:() => null,
      }}
      styles={SwSelectStyles}
      placeholder={placeholder}
      isClearable
      isMulti={isMulti}
    />
  );
};

export default SwSingleSelect;
